
export default {
    greenwich_mean_time: function () {
        return 'https://greenwichmeantime.com/time-zone/gmt-plus-7/';
    },
    share_facebook: function (url, title) {
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`;
    },
    share_twitter: function (url, title) {
        return `http://twitter.com/share?text=${title}&url=${url}`;
    },
    share_linkedin: function (url, title) {
        return `https://www.linkedin.com/shareArticle?url=${url}&title=${title}`;
    },
};
